import { useFlags } from 'launchdarkly-react-client-sdk';

import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';

type RevampJourneyHook = {
  isRevampJourney: boolean;
};

export const useRevampJourney = (): RevampJourneyHook => {
  const { releaseRevampJourney } = useFlags();
  const { isDSJourney, activePartner } = usePartner();
  const isQuoteByEmailJourney = activePartner[PARTNERS.QUOTE_BY_EMAIL];

  return {
    isRevampJourney: !!(
      releaseRevampJourney &&
      isDSJourney &&
      !isQuoteByEmailJourney
    )
  };
};
